import { PartnerDto } from '@/generated-types';

type TPartnerBrandingFields = {
	displayName?: string;
	dbaName?: string;
	applicationFooterText?: string;
};

type TPartnerLike = (Partial<Required<PartnerDto>> & TPartnerBrandingFields) | null | undefined;

export const getPartnerBrandName = (partner: TPartnerLike): string => {
	const displayName = (partner?.displayName ?? '').trim();
	const name = (partner?.name ?? '').trim();

	return displayName || name;
};

export const getPartnerApplicationFooterText = (partner: TPartnerLike): string | undefined => {
	const footerText = (partner?.applicationFooterText ?? '').trim();

	return footerText ? footerText : undefined;
};
